import React from 'react';
import { cx } from '../../../../utils/cx';

export type VerifiedTickSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';

export interface VerifiedTickProps {
  size: VerifiedTickSize;
  className?: string;
}

export const VerifiedTick: React.FC<VerifiedTickProps> = ({ size, className }) => (
  <span
    className={cx('uui-verified-tick', `uui-verified-tick--${size}`, 'uui-verified-tick--hoverable', className)}
    data-tooltip="Verified by ReffConnect"
  >
    <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.3 1.3a2.8 2.8 0 0 1 3.4 0l1.1.85a2.8 2.8 0 0 0 1.3.55l1.38.2a2.8 2.8 0 0 1 2.4 2.4l.2 1.38c.07.47.26.9.55 1.3l.85 1.1a2.8 2.8 0 0 1 0 3.4l-.85 1.1a2.8 2.8 0 0 0-.55 1.3l-.2 1.38a2.8 2.8 0 0 1-2.4 2.4l-1.38.2a2.8 2.8 0 0 0-1.3.55l-1.1.85a2.8 2.8 0 0 1-3.4 0l-1.1-.85a2.8 2.8 0 0 0-1.3-.55l-1.38-.2a2.8 2.8 0 0 1-2.4-2.4l-.2-1.38a2.8 2.8 0 0 0-.55-1.3l-.85-1.1a2.8 2.8 0 0 1 0-3.4l.85-1.1c.29-.4.48-.83.55-1.3l.2-1.38a2.8 2.8 0 0 1 2.4-2.4l1.38-.2a2.8 2.8 0 0 0 1.3-.55l1.1-.85Z"
        fill="#2563EB"
      />
      <path
        d="M7.5 11.2l2.1 2.1 4.9-4.9"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);
